import React from "react";
import Field from "../../sections/shared/Field";
import EditorGroup from "../../sections/shared/EditorGroup";

function normalizeTemplateKey(template) {
  const t = String(template || "").toLowerCase().trim();
  if (t === "1" || t === "template1" || t.endsWith("template1")) return "template1";
  if (t === "2" || t === "template2" || t.endsWith("template2")) return "template2";
  if (t === "3" || t === "template3" || t.endsWith("template3")) return "template3";
  return "";
}

export default function TestimonialsDesignSection({
  editedSection,
  t,
  flags,
  onStyleChange,
}) {
  const { isTestimonials } = flags;
  const templateKey = normalizeTemplateKey(editedSection?.template);

  const isTemplate1 = isTestimonials && templateKey === "template1";
  const isTemplate2 = isTestimonials && templateKey === "template2";
  const isTemplate3 = isTestimonials && templateKey === "template3";

  if (!isTemplate1 && !isTemplate2 && !isTemplate3) return null;

  return (
    <>
      <EditorGroup
        title={t("sectionModal.testimonialsShared.title", "Testimonials Colors")}
        subtitle={t(
          "sectionModal.testimonialsShared.help",
          "Customize shared testimonial card colors"
        )}
        defaultOpen={false}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field
            label={t("sectionModal.testimonialsShared.cardBg", "Card Background")}
            type="color"
            value={editedSection?.style?.testimonialsCardBg}
            onChange={(v) => onStyleChange("testimonialsCardBg", v)}
          />
          <Field
            label={t("sectionModal.testimonialsShared.cardBorder", "Card Border")}
            type="color"
            value={editedSection?.style?.testimonialsCardBorder}
            onChange={(v) => onStyleChange("testimonialsCardBorder", v)}
          />
          <Field
            label={t("sectionModal.testimonialsShared.nameColor", "Name Color")}
            type="color"
            value={editedSection?.style?.testimonialsNameColor}
            onChange={(v) => onStyleChange("testimonialsNameColor", v)}
          />
          <Field
            label={t("sectionModal.testimonialsShared.roleColor", "Role Color")}
            type="color"
            value={editedSection?.style?.testimonialsRoleColor}
            onChange={(v) => onStyleChange("testimonialsRoleColor", v)}
          />
          <Field
            label={t("sectionModal.testimonialsShared.contentColor", "Content Color")}
            type="color"
            value={editedSection?.style?.testimonialsContentColor}
            onChange={(v) => onStyleChange("testimonialsContentColor", v)}
          />
          <Field
            label={t("sectionModal.testimonialsShared.avatarBg", "Avatar Background")}
            type="color"
            value={editedSection?.style?.testimonialsAvatarBg}
            onChange={(v) => onStyleChange("testimonialsAvatarBg", v)}
          />
          <Field
            label={t("sectionModal.testimonialsShared.avatarText", "Avatar Text")}
            type="color"
            value={editedSection?.style?.testimonialsAvatarText}
            onChange={(v) => onStyleChange("testimonialsAvatarText", v)}
          />
          <Field
            label={t("sectionModal.testimonialsShared.starActive", "Active Star Color")}
            type="color"
            value={editedSection?.style?.testimonialsStarActiveColor}
            onChange={(v) => onStyleChange("testimonialsStarActiveColor", v)}
          />
          <Field
            label={t("sectionModal.testimonialsShared.starInactive", "Inactive Star Color")}
            type="color"
            value={editedSection?.style?.testimonialsStarInactiveColor}
            onChange={(v) => onStyleChange("testimonialsStarInactiveColor", v)}
          />
        </div>
      </EditorGroup>

      {isTemplate2 && (
        <EditorGroup
          title={t("sectionModal.testimonialsTemplate2.title", "Testimonials Template 2")}
          subtitle={t(
            "sectionModal.testimonialsTemplate2.help",
            "Customize the slider, navigation, and preview cards"
          )}
          defaultOpen={false}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.testimonialsTemplate2.quoteIcon", "Quote Icon Color")}
              type="color"
              value={editedSection?.style?.testimonialsQuoteIconColor}
              onChange={(v) => onStyleChange("testimonialsQuoteIconColor", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.mainCardBg", "Main Card Background")}
              type="color"
              value={editedSection?.style?.testimonialsMainCardBg}
              onChange={(v) => onStyleChange("testimonialsMainCardBg", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.mainCardBorder", "Main Card Border")}
              type="color"
              value={editedSection?.style?.testimonialsMainCardBorder}
              onChange={(v) => onStyleChange("testimonialsMainCardBorder", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.companyColor", "Company Color")}
              type="color"
              value={editedSection?.style?.testimonialsCompanyColor}
              onChange={(v) => onStyleChange("testimonialsCompanyColor", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.dotActive", "Active Dot")}
              type="color"
              value={editedSection?.style?.testimonialsDotActive}
              onChange={(v) => onStyleChange("testimonialsDotActive", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.dotInactive", "Inactive Dot")}
              type="color"
              value={editedSection?.style?.testimonialsDotInactive}
              onChange={(v) => onStyleChange("testimonialsDotInactive", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.navBtnBg", "Nav Button Background")}
              type="color"
              value={editedSection?.style?.testimonialsNavBtnBg}
              onChange={(v) => onStyleChange("testimonialsNavBtnBg", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.navBtnBorder", "Nav Button Border")}
              type="color"
              value={editedSection?.style?.testimonialsNavBtnBorder}
              onChange={(v) => onStyleChange("testimonialsNavBtnBorder", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.navBtnIcon", "Nav Button Icon")}
              type="color"
              value={editedSection?.style?.testimonialsNavBtnIcon}
              onChange={(v) => onStyleChange("testimonialsNavBtnIcon", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.previewBg", "Preview Card Background")}
              type="color"
              value={editedSection?.style?.testimonialsPreviewCardBg}
              onChange={(v) => onStyleChange("testimonialsPreviewCardBg", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.previewBorder", "Preview Card Border")}
              type="color"
              value={editedSection?.style?.testimonialsPreviewCardBorder}
              onChange={(v) => onStyleChange("testimonialsPreviewCardBorder", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.previewActiveBg", "Active Preview Background")}
              type="color"
              value={editedSection?.style?.testimonialsPreviewActiveBg}
              onChange={(v) => onStyleChange("testimonialsPreviewActiveBg", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate2.previewActiveBorder", "Active Preview Border")}
              type="color"
              value={editedSection?.style?.testimonialsPreviewActiveBorder}
              onChange={(v) => onStyleChange("testimonialsPreviewActiveBorder", v)}
            />
          </div>
        </EditorGroup>
      )}

      {isTemplate3 && (
        <EditorGroup
          title={t("sectionModal.testimonialsTemplate3.title", "Testimonials Template 3")}
          subtitle={t(
            "sectionModal.testimonialsTemplate3.help",
            "Customize the result cards, top icon, and result badges"
          )}
          defaultOpen={false}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.testimonialsTemplate3.topIconBg", "Top Icon Background")}
              type="color"
              value={editedSection?.style?.testimonialsTopIconBg}
              onChange={(v) => onStyleChange("testimonialsTopIconBg", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate3.topIconColor", "Top Icon Color")}
              type="color"
              value={editedSection?.style?.testimonialsTopIconColor}
              onChange={(v) => onStyleChange("testimonialsTopIconColor", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate3.metricBadgeBg", "Metric Badge Background")}
              type="color"
              value={editedSection?.style?.testimonialsMetricBadgeBg}
              onChange={(v) => onStyleChange("testimonialsMetricBadgeBg", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate3.metricBadgeText", "Metric Badge Text")}
              type="color"
              value={editedSection?.style?.testimonialsMetricBadgeText}
              onChange={(v) => onStyleChange("testimonialsMetricBadgeText", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate3.resultBadgeBg", "Result Badge Background")}
              type="color"
              value={editedSection?.style?.testimonialsResultBadgeBg}
              onChange={(v) => onStyleChange("testimonialsResultBadgeBg", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate3.resultBadgeText", "Result Badge Text")}
              type="color"
              value={editedSection?.style?.testimonialsResultBadgeText}
              onChange={(v) => onStyleChange("testimonialsResultBadgeText", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate3.accentBg", "Accent Background")}
              type="color"
              value={editedSection?.style?.testimonialsAccentBg}
              onChange={(v) => onStyleChange("testimonialsAccentBg", v)}
            />
            <Field
              label={t("sectionModal.testimonialsTemplate3.accentText", "Accent Text")}
              type="color"
              value={editedSection?.style?.testimonialsAccentText}
              onChange={(v) => onStyleChange("testimonialsAccentText", v)}
            />
          </div>
        </EditorGroup>
      )}
    </>
  );
}